import { makeObservable, observable, action } from 'mobx';
import ConversationsStore from './ConversationsStore';
import MessagesStore from './MessagesStore';

class ChatStore {
  selectedAgentId = null;
  selectedConversationId = null;
  selectedAgent = null; // Objeto completo del agente seleccionado

  constructor() {
    this.conversationsStore = new ConversationsStore();
    this.messagesStore = new MessagesStore();

    makeObservable(this, {
      selectedAgentId: observable,
      selectedConversationId: observable,
      selectedAgent: observable,
      setSelectedAgent: action,
      setSelectedConversation: action,
      setSelectedAgentData: action,
      clearSelection: action,
    });
  }

  setSelectedAgent(agentId) {
    this.selectedAgentId = agentId;
    this.selectedConversationId = null;
    this.selectedAgent = null; // Se cargará cuando se obtenga el agente
  }

  setSelectedConversation(conversationId) {
    this.selectedConversationId = conversationId;
    this.selectedAgentId = null;
    this.selectedAgent = null; // Se cargará cuando se obtenga el agente de la conversación
  }

  setSelectedAgentData(agentData) {
    this.selectedAgent = agentData;
    if (agentData?.uuid || agentData?.id) {
      this.selectedAgentId = agentData.uuid || agentData.id;
    }
  }

  clearSelection() {
    this.selectedAgentId = null;
    this.selectedConversationId = null;
    this.selectedAgent = null;
  }
}

export default new ChatStore();
